/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Lutely API
 * Lutely API
 * OpenAPI spec version: local
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AuthControllerEnsureUserBody,
  AuthControllerForgotPasswordBody,
  AuthControllerOauthInitBody,
  AuthControllerOtpInitBody,
  CheckEmailDto,
  CheckEmailResponseDto,
  PolicyAcceptanceDto,
  SignUpDto,
  UpdateEmailDto,
  UpdateUserDto,
  UserPayloadDto,
} from ".././dtos";

import { apiRequest } from "../../api-request";
import type { ErrorType, BodyType } from "../../api-request";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const authControllerCheckEmail = (
  checkEmailDto: BodyType<CheckEmailDto>,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<CheckEmailResponseDto>(
    {
      url: `/auth/check-email`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: checkEmailDto,
      signal,
    },
    options,
  );
};

export const getAuthControllerCheckEmailMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerCheckEmail>>,
    TError,
    { data: BodyType<CheckEmailDto> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerCheckEmail>>,
  TError,
  { data: BodyType<CheckEmailDto> },
  TContext
> => {
  const mutationKey = ["authControllerCheckEmail"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerCheckEmail>>,
    { data: BodyType<CheckEmailDto> }
  > = (props) => {
    const { data } = props ?? {};

    return authControllerCheckEmail(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerCheckEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerCheckEmail>>
>;
export type AuthControllerCheckEmailMutationBody = BodyType<CheckEmailDto>;
export type AuthControllerCheckEmailMutationError = ErrorType<unknown>;

export const useAuthControllerCheckEmail = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerCheckEmail>>,
      TError,
      { data: BodyType<CheckEmailDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerCheckEmail>>,
  TError,
  { data: BodyType<CheckEmailDto> },
  TContext
> => {
  const mutationOptions = getAuthControllerCheckEmailMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const authControllerSignUp = (
  signUpDto: BodyType<SignUpDto>,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<void>(
    {
      url: `/auth/signup`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: signUpDto,
      signal,
    },
    options,
  );
};

export const getAuthControllerSignUpMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerSignUp>>,
    TError,
    { data: BodyType<SignUpDto> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerSignUp>>,
  TError,
  { data: BodyType<SignUpDto> },
  TContext
> => {
  const mutationKey = ["authControllerSignUp"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerSignUp>>,
    { data: BodyType<SignUpDto> }
  > = (props) => {
    const { data } = props ?? {};

    return authControllerSignUp(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerSignUpMutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerSignUp>>
>;
export type AuthControllerSignUpMutationBody = BodyType<SignUpDto>;
export type AuthControllerSignUpMutationError = ErrorType<unknown>;

export const useAuthControllerSignUp = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerSignUp>>,
      TError,
      { data: BodyType<SignUpDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerSignUp>>,
  TError,
  { data: BodyType<SignUpDto> },
  TContext
> => {
  const mutationOptions = getAuthControllerSignUpMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const authControllerUpdateUser = (
  updateUserDto: BodyType<UpdateUserDto>,
  options?: SecondParameter<typeof apiRequest>,
) => {
  return apiRequest<void>(
    {
      url: `/auth/user`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateUserDto,
    },
    options,
  );
};

export const getAuthControllerUpdateUserMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerUpdateUser>>,
    TError,
    { data: BodyType<UpdateUserDto> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerUpdateUser>>,
  TError,
  { data: BodyType<UpdateUserDto> },
  TContext
> => {
  const mutationKey = ["authControllerUpdateUser"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerUpdateUser>>,
    { data: BodyType<UpdateUserDto> }
  > = (props) => {
    const { data } = props ?? {};

    return authControllerUpdateUser(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerUpdateUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerUpdateUser>>
>;
export type AuthControllerUpdateUserMutationBody = BodyType<UpdateUserDto>;
export type AuthControllerUpdateUserMutationError = ErrorType<unknown>;

export const useAuthControllerUpdateUser = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerUpdateUser>>,
      TError,
      { data: BodyType<UpdateUserDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerUpdateUser>>,
  TError,
  { data: BodyType<UpdateUserDto> },
  TContext
> => {
  const mutationOptions = getAuthControllerUpdateUserMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const authControllerVerifyEmail = (
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<void>(
    { url: `/auth/verify-email`, method: "POST", signal },
    options,
  );
};

export const getAuthControllerVerifyEmailMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerVerifyEmail>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerVerifyEmail>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["authControllerVerifyEmail"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerVerifyEmail>>,
    void
  > = () => {
    return authControllerVerifyEmail(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerVerifyEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerVerifyEmail>>
>;

export type AuthControllerVerifyEmailMutationError = ErrorType<unknown>;

export const useAuthControllerVerifyEmail = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerVerifyEmail>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerVerifyEmail>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getAuthControllerVerifyEmailMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const authControllerGetCurrentUser = (
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<UserPayloadDto>(
    { url: `/auth/me`, method: "GET", signal },
    options,
  );
};

export const getAuthControllerGetCurrentUserQueryKey = () => {
  return [`/auth/me`] as const;
};

export const getAuthControllerGetCurrentUserQueryOptions = <
  TData = Awaited<ReturnType<typeof authControllerGetCurrentUser>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof authControllerGetCurrentUser>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof apiRequest>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAuthControllerGetCurrentUserQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof authControllerGetCurrentUser>>
  > = ({ signal }) => authControllerGetCurrentUser(requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof authControllerGetCurrentUser>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AuthControllerGetCurrentUserQueryResult = NonNullable<
  Awaited<ReturnType<typeof authControllerGetCurrentUser>>
>;
export type AuthControllerGetCurrentUserQueryError = ErrorType<unknown>;

export function useAuthControllerGetCurrentUser<
  TData = Awaited<ReturnType<typeof authControllerGetCurrentUser>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof authControllerGetCurrentUser>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authControllerGetCurrentUser>>,
          TError,
          Awaited<ReturnType<typeof authControllerGetCurrentUser>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useAuthControllerGetCurrentUser<
  TData = Awaited<ReturnType<typeof authControllerGetCurrentUser>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof authControllerGetCurrentUser>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authControllerGetCurrentUser>>,
          TError,
          Awaited<ReturnType<typeof authControllerGetCurrentUser>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAuthControllerGetCurrentUser<
  TData = Awaited<ReturnType<typeof authControllerGetCurrentUser>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof authControllerGetCurrentUser>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useAuthControllerGetCurrentUser<
  TData = Awaited<ReturnType<typeof authControllerGetCurrentUser>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof authControllerGetCurrentUser>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAuthControllerGetCurrentUserQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const authControllerAcceptPolicies = (
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<PolicyAcceptanceDto>(
    { url: `/auth/accept-policies`, method: "POST", signal },
    options,
  );
};

export const getAuthControllerAcceptPoliciesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerAcceptPolicies>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerAcceptPolicies>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["authControllerAcceptPolicies"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerAcceptPolicies>>,
    void
  > = () => {
    return authControllerAcceptPolicies(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerAcceptPoliciesMutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerAcceptPolicies>>
>;

export type AuthControllerAcceptPoliciesMutationError = ErrorType<unknown>;

export const useAuthControllerAcceptPolicies = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerAcceptPolicies>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerAcceptPolicies>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getAuthControllerAcceptPoliciesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const authControllerUpdateEmailAddress = (
  updateEmailDto: BodyType<UpdateEmailDto>,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<void>(
    {
      url: `/auth/email-address`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: updateEmailDto,
      signal,
    },
    options,
  );
};

export const getAuthControllerUpdateEmailAddressMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerUpdateEmailAddress>>,
    TError,
    { data: BodyType<UpdateEmailDto> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerUpdateEmailAddress>>,
  TError,
  { data: BodyType<UpdateEmailDto> },
  TContext
> => {
  const mutationKey = ["authControllerUpdateEmailAddress"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerUpdateEmailAddress>>,
    { data: BodyType<UpdateEmailDto> }
  > = (props) => {
    const { data } = props ?? {};

    return authControllerUpdateEmailAddress(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerUpdateEmailAddressMutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerUpdateEmailAddress>>
>;
export type AuthControllerUpdateEmailAddressMutationBody =
  BodyType<UpdateEmailDto>;
export type AuthControllerUpdateEmailAddressMutationError = ErrorType<unknown>;

export const useAuthControllerUpdateEmailAddress = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerUpdateEmailAddress>>,
      TError,
      { data: BodyType<UpdateEmailDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerUpdateEmailAddress>>,
  TError,
  { data: BodyType<UpdateEmailDto> },
  TContext
> => {
  const mutationOptions =
    getAuthControllerUpdateEmailAddressMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const authControllerForgotPassword = (
  authControllerForgotPasswordBody: BodyType<AuthControllerForgotPasswordBody>,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<void>(
    {
      url: `/auth/forgot-password`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: authControllerForgotPasswordBody,
      signal,
    },
    options,
  );
};

export const getAuthControllerForgotPasswordMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerForgotPassword>>,
    TError,
    { data: BodyType<AuthControllerForgotPasswordBody> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerForgotPassword>>,
  TError,
  { data: BodyType<AuthControllerForgotPasswordBody> },
  TContext
> => {
  const mutationKey = ["authControllerForgotPassword"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerForgotPassword>>,
    { data: BodyType<AuthControllerForgotPasswordBody> }
  > = (props) => {
    const { data } = props ?? {};

    return authControllerForgotPassword(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerForgotPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerForgotPassword>>
>;
export type AuthControllerForgotPasswordMutationBody =
  BodyType<AuthControllerForgotPasswordBody>;
export type AuthControllerForgotPasswordMutationError = ErrorType<unknown>;

export const useAuthControllerForgotPassword = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerForgotPassword>>,
      TError,
      { data: BodyType<AuthControllerForgotPasswordBody> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerForgotPassword>>,
  TError,
  { data: BodyType<AuthControllerForgotPasswordBody> },
  TContext
> => {
  const mutationOptions =
    getAuthControllerForgotPasswordMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const authControllerGetLoginMethods = (
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<string[]>(
    { url: `/auth/login-methods`, method: "GET", signal },
    options,
  );
};

export const getAuthControllerGetLoginMethodsQueryKey = () => {
  return [`/auth/login-methods`] as const;
};

export const getAuthControllerGetLoginMethodsQueryOptions = <
  TData = Awaited<ReturnType<typeof authControllerGetLoginMethods>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof authControllerGetLoginMethods>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof apiRequest>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAuthControllerGetLoginMethodsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof authControllerGetLoginMethods>>
  > = ({ signal }) => authControllerGetLoginMethods(requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof authControllerGetLoginMethods>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AuthControllerGetLoginMethodsQueryResult = NonNullable<
  Awaited<ReturnType<typeof authControllerGetLoginMethods>>
>;
export type AuthControllerGetLoginMethodsQueryError = ErrorType<unknown>;

export function useAuthControllerGetLoginMethods<
  TData = Awaited<ReturnType<typeof authControllerGetLoginMethods>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof authControllerGetLoginMethods>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authControllerGetLoginMethods>>,
          TError,
          Awaited<ReturnType<typeof authControllerGetLoginMethods>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useAuthControllerGetLoginMethods<
  TData = Awaited<ReturnType<typeof authControllerGetLoginMethods>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof authControllerGetLoginMethods>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authControllerGetLoginMethods>>,
          TError,
          Awaited<ReturnType<typeof authControllerGetLoginMethods>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAuthControllerGetLoginMethods<
  TData = Awaited<ReturnType<typeof authControllerGetLoginMethods>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof authControllerGetLoginMethods>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useAuthControllerGetLoginMethods<
  TData = Awaited<ReturnType<typeof authControllerGetLoginMethods>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof authControllerGetLoginMethods>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAuthControllerGetLoginMethodsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const authControllerOauthInit = (
  authControllerOauthInitBody: BodyType<AuthControllerOauthInitBody>,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<void>(
    {
      url: `/auth/oauth-init`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: authControllerOauthInitBody,
      signal,
    },
    options,
  );
};

export const getAuthControllerOauthInitMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerOauthInit>>,
    TError,
    { data: BodyType<AuthControllerOauthInitBody> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerOauthInit>>,
  TError,
  { data: BodyType<AuthControllerOauthInitBody> },
  TContext
> => {
  const mutationKey = ["authControllerOauthInit"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerOauthInit>>,
    { data: BodyType<AuthControllerOauthInitBody> }
  > = (props) => {
    const { data } = props ?? {};

    return authControllerOauthInit(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerOauthInitMutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerOauthInit>>
>;
export type AuthControllerOauthInitMutationBody =
  BodyType<AuthControllerOauthInitBody>;
export type AuthControllerOauthInitMutationError = ErrorType<unknown>;

export const useAuthControllerOauthInit = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerOauthInit>>,
      TError,
      { data: BodyType<AuthControllerOauthInitBody> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerOauthInit>>,
  TError,
  { data: BodyType<AuthControllerOauthInitBody> },
  TContext
> => {
  const mutationOptions = getAuthControllerOauthInitMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const authControllerOtpInit = (
  authControllerOtpInitBody: BodyType<AuthControllerOtpInitBody>,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<void>(
    {
      url: `/auth/otp-init`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: authControllerOtpInitBody,
      signal,
    },
    options,
  );
};

export const getAuthControllerOtpInitMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerOtpInit>>,
    TError,
    { data: BodyType<AuthControllerOtpInitBody> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerOtpInit>>,
  TError,
  { data: BodyType<AuthControllerOtpInitBody> },
  TContext
> => {
  const mutationKey = ["authControllerOtpInit"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerOtpInit>>,
    { data: BodyType<AuthControllerOtpInitBody> }
  > = (props) => {
    const { data } = props ?? {};

    return authControllerOtpInit(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerOtpInitMutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerOtpInit>>
>;
export type AuthControllerOtpInitMutationBody =
  BodyType<AuthControllerOtpInitBody>;
export type AuthControllerOtpInitMutationError = ErrorType<unknown>;

export const useAuthControllerOtpInit = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerOtpInit>>,
      TError,
      { data: BodyType<AuthControllerOtpInitBody> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerOtpInit>>,
  TError,
  { data: BodyType<AuthControllerOtpInitBody> },
  TContext
> => {
  const mutationOptions = getAuthControllerOtpInitMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const authControllerEnsureUser = (
  authControllerEnsureUserBody: BodyType<AuthControllerEnsureUserBody>,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<void>(
    {
      url: `/auth/ensure-user`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: authControllerEnsureUserBody,
      signal,
    },
    options,
  );
};

export const getAuthControllerEnsureUserMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerEnsureUser>>,
    TError,
    { data: BodyType<AuthControllerEnsureUserBody> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerEnsureUser>>,
  TError,
  { data: BodyType<AuthControllerEnsureUserBody> },
  TContext
> => {
  const mutationKey = ["authControllerEnsureUser"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerEnsureUser>>,
    { data: BodyType<AuthControllerEnsureUserBody> }
  > = (props) => {
    const { data } = props ?? {};

    return authControllerEnsureUser(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerEnsureUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerEnsureUser>>
>;
export type AuthControllerEnsureUserMutationBody =
  BodyType<AuthControllerEnsureUserBody>;
export type AuthControllerEnsureUserMutationError = ErrorType<unknown>;

export const useAuthControllerEnsureUser = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerEnsureUser>>,
      TError,
      { data: BodyType<AuthControllerEnsureUserBody> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerEnsureUser>>,
  TError,
  { data: BodyType<AuthControllerEnsureUserBody> },
  TContext
> => {
  const mutationOptions = getAuthControllerEnsureUserMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
